import { memo } from 'react';
import { HStack } from '@chakra-ui/react';

import { useHeaderBoundStore } from 'app/selectors';
import NavItem from 'shared/NavItem';

import { navButtonsData } from 'constants/header';

const Navigation = props => {
  const { isLight } = useHeaderBoundStore();

  return (
    <HStack
      as="nav"
      minH={{ mg: '62px' }}
      gap={{ laptop: '30px', xd: '40px' }}
      transition="color .2s linear"
      color={`text.${!isLight ? 'black' : 'white'}`}
      {...props}
    >
      {navButtonsData.map((buttonData, i) => (
        <NavItem key={i} {...buttonData} />
      ))}
    </HStack>
  );
};

export default memo(Navigation);
